import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export const FolderDownloadIcon: FC<IconProps> = ({
  className,
  iconColor = '#344054',
  ...props
}) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8333 5.83333L9.90372 3.9741C9.63617 3.439 9.50239 3.17144 9.30281 2.97597C9.12632 2.80311 8.9136 2.67164 8.68006 2.59109C8.41597 2.5 8.11684 2.5 7.51858 2.5H4.33333C3.39991 2.5 2.9332 2.5 2.57668 2.68166C2.26308 2.84144 2.00811 3.09641 1.84832 3.41002C1.66667 3.76654 1.66667 4.23325 1.66667 5.16667V5.83333M1.66667 5.83333H14.3333C15.7335 5.83333 16.4335 5.83333 16.9683 6.10582C17.4387 6.3455 17.8212 6.72795 18.0608 7.19836C18.3333 7.73314 18.3333 8.4332 18.3333 9.83333V13.5C18.3333 14.9001 18.3333 15.6002 18.0608 16.135C17.8212 16.6054 17.4387 16.9878 16.9683 17.2275C16.4335 17.5 15.7335 17.5 14.3333 17.5H5.66667C4.26654 17.5 3.56647 17.5 3.03169 17.2275C2.56129 16.9878 2.17883 16.6054 1.93915 16.135C1.66667 15.6002 1.66667 14.9001 1.66667 13.5V5.83333ZM12.5 11.6667L10 14.1667L7.5 11.6667M10 14.1667V9.16667"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.3"
    />
  </svg>
);
